import { Backdrop, Box, Button, CircularProgress, Container, TextField, Typography } from "@mui/material";
import React, { useEffect } from "react";
import { Context } from "../../App";

export default function CompteInfoForm({onLogin}) {
    const { setIsConnected, setUserId, userId } = React.useContext(Context);
    const [loading, setLoading] = React.useState(false);
    const [user, setUser] = React.useState(null);

    const [password, setPassword] = React.useState('');
    const [confirmPassword, setConfirmPassword] = React.useState('');

    const [passwordError, setPasswordError] = React.useState('');
    const [msg, setMsg] = React.useState('');

    async function handleSubmit(e) {
        e.preventDefault();
        if(password!==''&&password.length < 8) {
            setPasswordError('Le mot de passe doit contenir au moins 8 caractères');
            return;
        } else if (password !== confirmPassword) {
            setPasswordError('Les mots de passe ne correspondent pas');
            return;
        } else {
            setPasswordError('');
            setLoading(true);

            fetch(`${process.env.REACT_APP_API_URL}/user/${userId}`, {
                method: 'PATCH',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token') || ''}`
                },
                body: JSON.stringify(user),
            })
            .then(async response => {
                const token = response.headers.get('x-auth-token');
                if (token) localStorage.setItem('token', token);
                if (response.status === 401) {
                    localStorage.removeItem('token');
                    localStorage.removeItem('user');
                    setIsConnected(false);
                    throw new Error('Unauthorized');
                }
                if (!response.ok) {
                    const text = await response.text();
                    setMsg((response.status!==500 ? text : null) || 'Erreur lors de l\'enregistrement');
                }else {
                    localStorage.setItem('token', response.headers.get('x-auth-token'));
                    const json = await response.json();
                    setUser(json);
                    setMsg('');
                }
                setLoading(false);
            })
            .catch(error => {
                setLoading(false);
                console.error('Erreur lors de l\'inscription :', error);
                alert('Une erreur est survenue. Veuillez réessayer plus tard.');
            });
        }
    }

    React.useEffect(()=>{
        fetch(`${process.env.REACT_APP_API_URL}/user/${userId}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json', 
            'Authorization': `Bearer ${localStorage.getItem('token') || ''}`
            }
        })
        .then(response => {
            const token = response.headers.get('x-auth-token');
            if (token) localStorage.setItem('token', token);
            if (response.status === 401) {
                localStorage.removeItem('token');
                localStorage.removeItem('user');
                setIsConnected(false);
                throw new Error('Unauthorized');
            }
            if (!response.ok) {
                throw new Error('Failed to fetch user data');
            }
            return response.json();
        })
        .then(data => {
            setUser(data);
        })
        .catch(error => {
            console.error('Error fetching user data:', error);
            alert('Une erreur est survenue lors de la mise à jour de vos données. Veuillez réessayer plus tard.');
        });
    }, [])

    return (
    <Container maxWidth="sm" sx={{ display:'flex', flexDirection:'column', rowGap:2, minWidth: {xs:'auto', sm: '400px'} }}>
        <Typography variant="h4" align="center" sx={{ mb: 2 }}>Mettre à jour mes informations</Typography>

        {msg && <Typography variant="body1" color="error" sx={{ mb: 2 }}>{msg}</Typography>}

        {!!user&&<>
            <Box component="form" onSubmit={handleSubmit} sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                <TextField fullWidth select label="Civilité" variant="outlined" value={user.genre} required
                onChange={(e) => setUser(old=> ({...old, genre: e.target.value}))} slotProps={{ select: {native: true} }}>
                    <option value="Mr">Monsieur</option>
                    <option value="Mme">Madame</option>
                </TextField>

                <TextField fullWidth label="Nom" variant="outlined" value={user.nom} required
                onChange={(e) => setUser(old=> ({...old, nom: e.target.value}))} />
                <TextField fullWidth label="Prénoms" variant="outlined" value={user.prenom} required
                onChange={(e) => setUser(old=> ({...old, prenom: e.target.value}))} />

                <TextField fullWidth label="Adresse e-mail" variant="outlined" value={user.mail} required type="email"
                onChange={(e) => setUser(old=> ({...old, mail: e.target.value}))} />

                <TextField fullWidth type="phone" label="GSM" variant="outlined" value={user.tel} 
                onChange={(e) => setUser(old=> ({...old, tel: e.target.value}))} />

                <Typography variant="h6" sx={{ mt: 2 }}>Adresse</Typography>
                <TextField fullWidth label="Numéro et nom de la voie" variant="outlined" value={user.voie}
                onChange={(e) => setUser(old=> ({...old, voie: e.target.value}))} sx={{ mb: 2 }} />
                <TextField fullWidth label="Complément d'adresse" variant="outlined" value={user.adresse_complement}
                onChange={(e) => setUser(old=> ({...old, adresse_complement: e.target.value}))} sx={{ mb: 2 }} />
                <TextField fullWidth label="Code postal" variant="outlined" value={user.zip_code} required
                onChange={(e) => setUser(old=> ({...old, zip_code: e.target.value}))} sx={{ mb: 2 }} />
                <TextField fullWidth label="Ville" variant="outlined" value={user.ville} required
                onChange={(e) => setUser(old=> ({...old, ville: e.target.value}))} sx={{ mb: 2 }} />

                <Button variant="contained" type='submit'>Mettre à jour</Button>
            </Box>

            {/* <Typography variant="h6" sx={{ mt: 2 }}>Mot de passe</Typography>
            <TextField fullWidth type="password" label="Mot de passe" variant="outlined" required
            onChange={(e) => setPassword(e.target.value)} />
            <TextField fullWidth type="password" label="Confirmer le mot de passe" variant="outlined" required error={!!passwordError}
            helperText={passwordError} onChange={(e) => setConfirmPassword(e.target.value)} sx={{ mb: 4 }} />
            <Button variant="contained" type='submit' sx={{alignSelf: 'center', px: 5, mb: 2}}>Modifier le mot de passe</Button> */}

            {msg && <Typography variant="body1" color="error" sx={{ my: 2 }}>{msg}</Typography>}
        </>}
        <Backdrop open={loading}><CircularProgress/></Backdrop>

    </Container>
    )
}